import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';
import { Button } from '@mui/material';
import DashCarregamentoDialog from '../DashCarregamentoDialog';
import { calcularTamanhoFonte } from '../../../utils/fontSize';
import api from '../../../services/api';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const formatarValor = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(valor);
};

const Dashboard = ({ isPaused, setIsPaused }) => {

    const [dados, setDados] = useState([]);
    const [dadosDialog, setDadosDialog] = useState([]);
    const [modalAberto, setModalAberto] = useState(false);
    const [cargaFiltro, setCargaFiltro] = useState('');
    const [nroCargaFiltro, setNroCargaFiltro] = useState('');
    const [produtoFiltro, setProdutoFiltro] = useState('');

    useEffect(() => {
        api.get('/carregamentodia_dash')
            .then(response => setDados(response.data))
            .catch(error => console.error('Erro ao carregar os dados:', error));
    }, []);

    useEffect(() => {
        api.get('/carregamentodia_detalhado')
            .then(response => setDadosDialog(response.data))
            .catch(error => console.error('Erro ao carregar os dados:', error));
    }, []);

    function abrirModal() {
        setModalAberto(true);
        setIsPaused(true);
    }

    function fecharModal() {
        setModalAberto(false);
        // setIsPaused(false);
    }

    const meta = dados.Meta;
    const qtdeCarga = dados.qtdeCarga;
    const PesoCarregado = dados.PesoCarregado;

    const chartData = {
        labels: ['CARGAS DO DIA'],
        datasets: [
            {
                label: 'META',
                data: [meta],
                backgroundColor: ['#1976d2']
            },
            {
                label: 'CARREGADO (KG)',
                data: [PesoCarregado],
                backgroundColor: ['#D43994FF']
            },
            {
                label: 'PROGRAMADO (KG)',
                data: [qtdeCarga],
                backgroundColor: ['#26a69a']
            }
        ]
    };

    const chartOptions = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
                labels: {
                    color: '#fff',
                    font: {
                        size: calcularTamanhoFonte('label')
                    }
                }
            },
            datalabels: {
                anchor: 'end',
                align: 'bottom',
                color: '#fff',
                font: {
                    weight: 'bold',
                    size: calcularTamanhoFonte('datalabel')
                },
                formatter: (value) => formatarValor(value),
                offset: 4,
                clip: false
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#fff',
                    font: {
                        size: calcularTamanhoFonte('scales')
                    }
                },
                grid: { color: '#444' }
            },
            y: {
                ticks: {
                    color: '#fff',
                    font: {
                        size: calcularTamanhoFonte('scales')
                    }
                },
                grid: { color: '#444' }
            }
        }
    };

    return (
        <div>
            <h1>Carregamento do Dia</h1>
            <div style={{ height: '80vh', overflow: 'hidden', padding: '20px', boxSizing: 'border-box', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Bar data={chartData} options={chartOptions} sx={{ mb: 2 }} />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
                <Button variant="contained" color="success" onClick={abrirModal} style={{ marginTop: '20px' }}>
                    📊 Detalhes do carregamento
                </Button>
            </div>

            <DashCarregamentoDialog
                open={modalAberto}
                onClose={fecharModal}
                dados={dadosDialog}
                cargaFiltro={cargaFiltro}
                setCargaFiltro={setCargaFiltro}
                nroCargaFiltro={nroCargaFiltro}
                setNroCargaFiltro={setNroCargaFiltro}
                produtoFiltro={produtoFiltro}
                setProdutoFiltro={setProdutoFiltro}
            />

        </div >
    );
};

export default Dashboard;
